import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import { lmLength } from '@/utils/helpers';
import CTA from '@/components/shared/CTA';
import Image from '@/components/shared/Image';
import Menu from '@/components/shared/Menu';
import MLSSearchWidget from '@/components/shared/MLSSearchWidget';

const lmParse: ( string: string | JSX.Element ) => React.ReactElement | string = ( string ): React.ReactElement | string => {
    if ( ! lmLength( string ) ) {
        return '';
    }
    const options = {
        replace: ( domNode: Record<string, any> ): any => {
            if ( domNode.name === 'cta' ) {
                return (
                    <>
                    <CTA { ...domNode.attribs } />
                    { domToReact( domNode.children, options ) }
                    </>
                )
            }
            if ( domNode.name === 'image' ) {
                return (
                    <>
                    <Image { ...domNode.attribs } />
                    { domToReact( domNode.children, options ) }
                    </>
                )
            }
            if ( domNode.name === 'mlssearchwidget' ) {
                return (
                    <>
                    <MLSSearchWidget />
                    { domToReact( domNode.children, options ) }
                    </>
                )
            }
            if ( domNode.name === 'socialmenu' ) {
                return (
                    <>
                    <Menu name="social-nav" />
                    { domToReact( domNode.children, options ) }
                    </>
                )
            }
        }
    };
    return parse( string.toString(), options ) as React.ReactElement;
}
export default lmParse;